import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {InductionService} from "../../induction/induction.service";
import {LogService} from "../../../../../services/log.service";
import {Router} from "@angular/router";
import {PermissionType} from "../../../../../components/employee/PermissionType.enum";
import {SpecialDay} from "../special-day.model";
import {SpecialDayService} from "../special-day.service";
import {AddEditInductionComponent} from "../../induction/add-edit-induction/add-edit-induction.component";
import {AddEditSpecialDayComponent} from "../add-edit-special-day/add-edit-special-day.component";
import {MatDialog} from "@angular/material/dialog";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import {FormControl} from "@angular/forms";
import {Observable, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {EmployeeService} from "../../../../../services/employee.service";
import {CentreOption} from "../../educationObservation/education-observation.model";
import {CentreService} from "../../../../../services/centre.service";
import {MatSelectChange} from "@angular/material/select";
import {FinancialYearService} from "../../../../../services/financial-year.service";

@Component({
  selector: 'app-special-day-list',
  templateUrl: './special-day-list.component.html',
  styleUrls: ['./special-day-list.component.scss']
})
export class SpecialDayListComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();

  displayedColumns: string[] = [
    'srNo',
    'date',
    'teacherName',
    'centreName',
    'specialDay',
    'actions'
  ];

  displaySpecialDay = (c: any) => c;
  startDate = new FormControl<Date | null>(null);
  endDate = new FormControl<Date | null>(null);
  _specialDay$: Observable<string[]>
  selectedSpecialDay: any = null;
  specialDaySearchText: string = '';
  specialDayDebounceTimer: any;
  specialDayList: string[] = [];
  filteredSpecialDayTypes: any[] = [];
  mTeacher: string | null = null
  teachers$!: Observable<any[]>
  SelectCentre = new FormControl('')
  centres$!: Observable<CentreOption[]>;
  allSpecialDays: SpecialDay[] = [];         // ← add this
  selectedCentre: string | null = null;      // ← add this
  isLoading = false;

  dataSource = new MatTableDataSource<SpecialDay>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private specialDayService: SpecialDayService,
    private mLogService : LogService,
    private router: Router,
    private  readonly matDialog:MatDialog,
    private dialog: MatDialog,
    private readonly mDatabase: AngularFireDatabase,
    private readonly mEmployeeService: EmployeeService,
    private readonly centreService: CentreService,
    private readonly financialYearService: FinancialYearService,
  ) {
    this._specialDay$ = this.mDatabase.list<string>('types/Special Day').valueChanges();
    this._specialDay$.pipe(takeUntil(this._destroyed$)).subscribe(d => this.specialDayList = d);
    this.teachers$ = this.mEmployeeService.getTeachers()
    this.centres$ = centreService.getAllCentres()
  }

  ngOnInit(): void {
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate.setValue(fy.startDate);
    this.endDate.setValue(fy.endDate);
    this.loadList();
  }

  loadList() {
    this.specialDayService.getAll().pipe(takeUntil(this._destroyed$)).subscribe((data: any) => {
      const sorted = data.sort((a: any, b: any) => {
        const dateA = a.date?.toDate().getTime() ?? 0;
        const dateB = b.date?.toDate().getTime() ?? 0;
        return dateB - dateA;  // descending
      });

      this.allSpecialDays = sorted;
      this.dataSource.data = sorted;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  applyFilter(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    this.dataSource.filter = input.value.trim().toLowerCase();
  }

  onCentreChange(event: MatSelectChange) {
    this.selectedCentre = event.value;
  }

  search() {
    this.isLoading = true;

    const centre = this.selectedCentre || this.SelectCentre.value || 'All';
    const teacher = this.mTeacher || 'All';
    const specialDay = this.selectedSpecialDay || 'All';

    const from = this.startDate.value
      ? new Date(new Date(this.startDate.value).setHours(0, 0, 0, 0))
      : null;

    const to = this.endDate.value
      ? new Date(new Date(this.endDate.value).setHours(23, 59, 59, 999))
      : null;

    let filtered = [...this.allSpecialDays];

    if (centre !== 'All') {
      filtered = filtered.filter(item => item.centreCode === centre);
    }

    if (teacher !== 'All') {
      filtered = filtered.filter(item => item.teacherName === teacher);
    }

    if (specialDay !== 'All') {
      filtered = filtered.filter(item => item.specialDay === specialDay);
    }

    if (from && to) {
      filtered = filtered.filter(item => {
        const itemDate = item.date?.toDate();
        return itemDate >= from && itemDate <= to;
      });
    }

    this.dataSource = new MatTableDataSource(filtered);
    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;
    this.paginator?.firstPage();

    this.isLoading = false;
  }

  clearAll() {
    this.selectedCentre = 'All';
    this.SelectCentre.setValue('All');
    this.mTeacher = 'All';
    this.selectedSpecialDay = null;
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate.setValue(fy.startDate);
    this.endDate.setValue(fy.endDate);

    this.dataSource = new MatTableDataSource(this.allSpecialDays);
    this.dataSource.sort = this.sort!;
    this.dataSource.paginator = this.paginator!;
    this.paginator?.firstPage();
  }


  addSpecialDay() {
    // this.router.navigate(['/home/education/add-special-day']);

    const dialogRef = this.dialog.open(AddEditSpecialDayComponent, {
      width: '900px',
      maxHeight: '80vh',
      disableClose: true,
      autoFocus: false,
      data: null
    });
  }

  edit(row: SpecialDay) {
    // this.router.navigate(['/home/education/edit-special-day', row.id]);

    this.matDialog.open(AddEditSpecialDayComponent,{data:row,
      width:'900px',
      autoFocus:false
    })
  }

  view(row: any) {
    // ✅ Add activity log before navigation
    const activity = {
      date: new Date().getTime(),
      section: 'Special Day',
      action: 'Viewed',
      description: `Special Day viewed by user`,
      currentIp: localStorage.getItem('currentip')!
    };
    this.mLogService.addLog(activity);

    // ✅ Navigate to view page
    this.router.navigate(['/home/education/special-day-view', row.id]);
  }



  delete(id: string | undefined) {
    if (!id) return;

    if (confirm('Are you sure to delete this Special Day?')) {
      this.specialDayService.deleteRow(id)
        .then(() => {
          alert('Special Day deleted successfully');

          // ✅ Add activity log
          const activity = {
            date: new Date().getTime(),
            section: 'Special Day',
            action: 'Deleted',
            description: `Special Day deleted by user`,
            currentIp: localStorage.getItem('currentip')!
          };
          this.mLogService.addLog(activity);
        })
        .catch((error) => {
          console.error('Error deleting Special Day:', error);
          alert('Error deleting Special Day!');
        });
    }
  }
  downloadExcel(): void {
    const data = this.dataSource?.filteredData || [];

    if (!data.length) {
      return;
    }

    const exportData = data.map((row: any, index: number) => ({
      'Sr No': index + 1,
      'Date': row.date ? row.date.toDate().toLocaleDateString() : '',
      'Teacher': row.teacherName || '',
      'Centre': row.centreName || '',
      'Special Day': row.specialDay || ''
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Special Day': worksheet },
      SheetNames: ['Special Day']
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    this.saveAsExcelFile(excelBuffer, 'Special_Day_List');
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/octet-stream'
    });
    FileSaver.saveAs(data, `${fileName}_${new Date().getTime()}.xlsx`);
  }

  // handleAdd(event: any) {
  //   console.log("Add button clicked in child:", event);
  //   this.openAddTypeDialog(); //
  // }


  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;


}
